module.exports = __webpack_public_path__ + "fonts/SamsungOne-600v10.3a7b5cd5.woff2";